export function parseMetadataNumber(
  value: string | undefined,
  fallback: number
): number {
  if (!value) return fallback;
  const parsed = parseInt(value, 10);
  if (isNaN(parsed)) {
    return fallback;
  }
  return parsed;
}
